import { useCallback, useState } from "react"

const useWin = () => {
    const [open, setOpen] = useState(false)

    const winOpenChange = useCallback((isOpen: boolean) => {
        setOpen(isOpen)
    }, [])

    return { open, winOpenChange }
}

export default useWin